import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { FlightSchoolResponse } from '@fsp-lib/discovery-flights';

@Injectable({
  providedIn: 'root',
})
export class OperatorContextService {
  private currentOperatorSubject =
    new BehaviorSubject<FlightSchoolResponse | null>(null);

  constructor() {
    // No initialization from storage needed
  }

  setCurrentOperator(operator: FlightSchoolResponse): void {
    this.currentOperatorSubject.next(operator);
  }

  getCurrentOperator(): Observable<FlightSchoolResponse | null> {
    return this.currentOperatorSubject.asObservable();
  }

  getCurrentOperatorValue(): FlightSchoolResponse | null {
    return this.currentOperatorSubject.value;
  }

  clearOperator(): void {
    this.currentOperatorSubject.next(null);
  }
}
